export default {"src":"/_next/static/media/medical-devices.3d9e1031.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};